module.exports = __webpack_public_path__ + "img/kaze.5e7b7575.jpg";